import React from "react";
import { TorahAnytimeAvailabilityModalTemplate } from "themes/application/torah-anytime/components";

function TorahAnytimeAvailabilityModal(props) {
    return <TorahAnytimeAvailabilityModalTemplate {...props} />;
}

export default TorahAnytimeAvailabilityModal;
